import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const formatAmount = (n) => {
    const value = Number(n || 0).toFixed(2);
    return `$${value}`;
};

const AllocationMismatchBox = ({ chargeAmount = 0, allocatedAmount = 0, difference }) => {
    const diff =
        typeof difference === 'number'
            ? difference
            : Number((chargeAmount - allocatedAmount).toFixed(2));

    return (
        <Box
            sx={{
                mt: 2,
                p: 2,
                borderRadius: '8px',
                background: '#FDEAE8',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
            }}
            role="alert"
            aria-live="assertive"
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ErrorOutlineIcon sx={{ color: '#E43D30', width: '24px', height: '24px' }} />
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 400,
                        color: '#E43D30',
                        lineHeight: '22px',
                        fontSize: '14px',
                    }}
                >
                    Action required. Amounts do not match.
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography
                    variant="body2"
                    sx={{ color: 'var(--Midnight-100, #001E32)', fontWeight: '400' }}
                >
                    Charge Amount:
                </Typography>
                <Typography variant="body2" sx={{ color: 'var(--Midnight-100, #001E32)' }}>
                    {formatAmount(chargeAmount)}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="body2" sx={{ color: '#001E32', fontWeight: '400' }}>
                    Allocated&nbsp; Amount:
                </Typography>
                <Typography variant="body2" sx={{ color: '#001E32', fontWeight: '400' }}>
                    {formatAmount(allocatedAmount)}
                </Typography>
            </Box>

            <Divider />

            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 400,
                        color: '#001E32',
                        fontWeight: '400',
                    }}
                >
                    Difference:
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 700, color: '#AF2613' }}>
                    {formatAmount(Math.abs(diff))}
                </Typography>
            </Box>

            <Typography variant="body2" sx={{ fontSize: '12px' }}>
                Please ensure the charge amount is equal to the allocated amount before submitting.
            </Typography>
        </Box>
    );
};

export default AllocationMismatchBox;
